import axios from "axios";
import qs from "qs" // 序列化请求数据
import { Toast, Dialog } from 'vant'
var baseUrl = BASEURL;

// if(process.env.NODE_ENV == 'development') {
// 	baseUrl = "http://hdwx.museum-edu.cn/api";
// } else if(process.env.NODE_ENV == 'production') {
// 	baseUrl = "http://hdwx.museum-edu.cn/api";
// }

const axios_instance = axios.create({
	// 基础url前缀
	baseURL: baseUrl,
	// 请求头信息
	headers: {
		"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
		Accept: "application/json"
	},
	// 设置超时时间
	timeout: 10000,
	// 携带凭证
	// 返回数据类型
	responseType: "json",
});

// 添加请求拦截器
axios_instance.interceptors.request.use(config => {
	// 在发送请求之前做些什么
	if(config.isLoading) {
		window.toast = Toast.loading({
			mask: true,
			message: config.loadingText || '',
			duration: 0,
			forbidClick: true,
			mask: false
		});
	}
	return config;
}, error => {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
axios_instance.interceptors.response.use(
	response => {
		if(response.config.isLoading) window.toast.clear();
		if(response.data.status == 405) {
			if(!isWxEnv()) {
				Dialog.alert({
					title: '提示',
					message: '请在微信环境下使用'
				}).then(() => {
					// on close
				});
			} else {
				location.href = "/wx_oauth?vue_url=" + window.location.hash.replace('#','');
			}
		} else if(response.data.status == 0) {
			Toast(response.data.msg);
		} else {
			return response.data;
		}
		// return response.data;
	},
	err => {
		if(response.config.isLoading) window.toast.clear();
		Toast('显现错误');
		return Promise.reject(err);
	}
);
/**
 * 微信环境判断
 */
const isWxEnv = () => {
	let ua = navigator.userAgent.toLowerCase();
	return ua.match(/MicroMessenger/i) == "micromessenger";
};
export default function(url = "", data = {}, type = "GET", toastConfig = {}) {
	type = type.toUpperCase();
	return new Promise((resolve, reject) => {
		if(type === "GET") {
			var options = {
				url,
				method: "get",
				params: data
			};
		} else if(type === "POST") {
			var options = {
				url,
				method: "post",
				data: qs.stringify(data)
			};
		}
		axios_instance({ ...options,
				...toastConfig
			})
			.then(function(res) {
				resolve(res);
				return false;
			})
			.catch(function(err) {
				reject(err);
			});
	});
};


// WEBPACK FOOTER //
// ./src/http/api.js